"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementHeight = void 0;
var getElementHeight = function (element) {
    var _a;
    var htmlElement = document.getElementsByClassName(element);
    var height = (_a = htmlElement[0]) === null || _a === void 0 ? void 0 : _a.offsetHeight;
    if (!height)
        return '';
    return height + 12 + 'px';
};
exports.getElementHeight = getElementHeight;
